import { ALL_CALL_SETTING } from "../../constant/ActionType";

export default function AllCallSettingReducer(
    state = {
        allCallsetting: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_CALL_SETTING:
            return {
                ...state,
                allCallsetting: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
